import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '../ListItem';
import ChannelGroup from '../ChannelGroup';

const DirectMessages = ({
  dms,
  activeChannelId,
  onMessageSelect,
  openDirectMessageModal,
  channelsWithNewMessages,
  ...props
}) => {
  return (
    <ChannelGroup
      groupTitle='Direct Messages'
      tooltip='Open a Direct Message'
      onGroupTitleClick={() => {}}
      createChannel={openDirectMessageModal}
    >
      { dms.map(directMessage => {
        const { id, name } = directMessage;

        return (
          <ListItem
            showBadge
            key={`direct-message-${id}`}
            isActive={activeChannelId === id}
            messageCount={channelsWithNewMessages[id] || 0}
            onClick={() => onMessageSelect(id, directMessage)}
          >{name}</ListItem>
        );
      })}
    </ChannelGroup>
  );
};

DirectMessages.propTypes = {
  dms: PropTypes.array,
  activeChannelId: PropTypes.string,
  onMessageSelect: PropTypes.func,
  openDirectMessageModal: PropTypes.func,
  channelsWithNewMessages: PropTypes.shape({
    [PropTypes.number]: PropTypes.bool
  })
};

export default DirectMessages;
